import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease: [0.16, 1, 0.3, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const SectionLabel = ({ children }) => (
  <span
    data-testid="section-label"
    className="text-xs md:text-sm font-spacemono uppercase tracking-[0.25em] text-[#00F0FF]"
  >
    {children}
  </span>
);
